// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3M6wm","messages":"Chat_messages__1daoM","dateDivider":"Chat_dateDivider__vOtTM"};